<template>
  <div id="header" class="md-layout-row">
    <div class="web-page-container" style="height: 1000px">
      <div class="relative mock-navbar"></div>
      <div class="navbar flex-center">
        <div class="flex-center cursor-pointer" @click.prevent="routerLink('/')">
            <img
              :src="require(`@/assets/images/wv-monthly-insights/Icon.png`)"
              style="width: 32px; higth: 32px"
              class="ml-15 animation-logo"
              alt="logo happily"
            />
          <div class="fc-FFFFFF fs-18 fw-700 ml-6">My Happily</div>

        </div>
        <div class="hamburger-bar" @click.prevent="showNavbar = !showNavbar">
          <div class="line-menu"></div>
          <div class="line-menu"></div>
          <div class="line-menu"></div>
        </div>
      </div>
      <div class="flex">
        <div :class="`menu-container ${showNavbar ? 'show-menu' : ''}`">
          <div class="side-menu" :style="`height: ${maxHeightMenu}px;`">
            <div class="header-menu" ref="head_menu">
              <div class="flex-center mb-26 happily-logo cursor-pointer" @click.prevent="routerLink('/')">
                <img
                  :src="require(`@/assets/images/wv-monthly-insights/Icon.png`)"
                  style="width: 45px; higth: 45px"
                  class="animation-logo"
                  alt="logo happily"
                />
                <div class="fc-FFFFFF fs-24 fw-700 ml-12">My Happily</div>
              </div>
              <div>
                <img
                  v-if="user.profilepic_crop"
                  v-lazy="user.profilepic_crop"
                  :alt="user.firstname + ' ' + user.lastName"
                  :key="user.pic"
                  class="image-skeleton image-profile-48 flex-mid mr-12"
                />
                <img
                  v-else-if="user.pic"
                  v-lazy="user.pic"
                  :alt="user.firstname + ' ' + user.lastName"
                  :key="user.pic"
                  class="image-skeleton image-profile-48 flex-mid mr-12"
                />
                <div v-else class="image image-profile-48 flex-mid mr-12">
                  <div class="text-in-image text-in-image-48 flex-mid">
                    <span class="fw-700">{{
                      $utils("acronymName", {
                        firstName: user.firstname,
                        lastName: user.lastname,
                      })
                    }}</span>
                  </div>
                </div>
              </div>
              <div class="mt-14 flex">
                <div class="name mr-20">
                  {{ user.firstname }} {{ user.lastname }}
                </div>
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    <span class="pt-4 fs-14 fc-FFFFFF">
                      <i class="el-icon-caret-bottom el-icon--right"></i>
                    </span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="logout">Logout</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="mt-26 fs-20 fw-800 fc-FFFFFF">
                {{ user.company_name }}
              </div>
            </div>
            <div class="body-menu" ref="body_menu">
              <div
                v-for="(menu, index) in sideMenu"
                :key="menu.path + '_' + index"
              >
                <div
                  :class="`router flex-center ${linkActive(menu.path)}`"
                  v-if="userPerm(menu.path)"
                  @click.prevent="routerLink(menu.path)"
                >
                  <div>
                    <img :src="menu.imge" />
                  </div>
                  <div class="label">{{ menu.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="components-container py-16"
          ref="container_of_body"
          style="min-width: 1024px"
        >
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    this.$store.dispatch("authen/getCompanyData", this.user);
  },
  watch: {
    $route(to, from) {
      this.timeChecked = 1;
      this.checkedHeight();

    },
  },
  computed: {
    companyData() {
      return this.$store.getters["authen/companyData"];
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    activeIndex() {
      return this.$store.getters["authen/activeIndex"];
    },
    tutoriat() {
      let status = false;
      if (this.$route.query.welcome == "true") {
        status = true;
        this.stepTutorial = 1;
      } else if (this.$route.query.welcome == "false") {
        status = true;
      }
      setTimeout(() => {
        this.visible = status;
        return status;
      }, 500);
    },
    pagePermission() {
      return this.$store.getters["authen/pagePermission"];
    },
  },
  data() {
    return {
      insightsActive: false,
      membersActive: false,
      visible: false,
      stepTutorial: 1,
      showNavbar: false,
      maxHeightMenu: 350,
      timeChecked: 1,
      sideMenu: [
        // 1 : insights
        {
          label: "Insights",
          path: "insights",
          imge: require("@/assets/images/navbar/round-insights-24px.png"),
        },
        // 2 : members
        {
          label: "Members",
          path: "members",
          imge: require("@/assets/images/navbar/round-members-24px.png"),
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("authen/pagePermission");
    this.checkedHeight();
  },
  methods: {
    handleCommand(command) {
      if (command == "logout") {
        this.$store.dispatch("authen/logout");
      }
    },
    logout() {
      this.$store.dispatch("authen/logout");
    },
    checkCurrentRoute() {
      if (this.$route.path == "/") {
        if (this.user.user_type == "admin") {
          this.membersActive = true;
        } else {
          this.insightsActive = true;
        }
      } else {
        this.insightsActive = false;
        this.membersActive = false;
      }
    },
    routerLink(path) {
      this.$router.push(path);
    },
    linkActive(path) {
      if (this.$router.currentRoute.path === "/" + path) {
        return "active";
      } else if (this.$router.currentRoute.path == '/' && this.user) {
        if (this.user.user_type == "admin" && path == 'members') {
          return "active";
        } else if (path == 'insights') {
          return "active";
        }
      }
      return "";
    },
    async checkedHeight() {
      if (this.timeChecked < 300) {
        if (this.timeChecked < 30) {
          await this.$utils("waitingTime", 300);
        } else if (this.timeChecked < 50) {
          await this.$utils("waitingTime", 500);
        } else {
          await this.$utils("waitingTime", 1000);
        }
        if (
          this.$refs.container_of_body &&
          this.$refs.body_menu &&
          this.$refs.head_menu
        ) {
          let height = 1000;
          if (this.$refs.container_of_body.clientHeight > 1000) {
            height = this.$refs.container_of_body.clientHeight
          }
          this.maxHeightMenu = height;
        }
        this.timeChecked == this.timeChecked++;
        this.checkedHeight();
        if (this.timeChecked == 5) {
          this.redirectPath()
        }
      }
    },
    redirectPath() {
      let reFormant = this.$router.currentRoute.path.split("-").join("_");
      let redirect = true;
      if (this.pagePermission && reFormant.length > 0) {
        reFormant = reFormant.slice(1, reFormant.length)
        const user_type = this.user.user_type;
        if (
          this.pagePermission[reFormant] &&
          this.pagePermission[reFormant][user_type] != undefined
        ) {
          if (reFormant == "integrations" && this.companyData) {
            const perm =
              this.companyData.show_integration &&
              this.companyData.show_integration == "Y";
            
            redirect = perm && this.pagePermission[reFormant][user_type];
          } else {
            redirect = this.pagePermission[reFormant][user_type];
          }
        }
      }
      if (!redirect) {
        this.$router.push('/');
        this.$message({
          showClose: true,
          message: "Forbidden you don't have permission to access",
          type: "error"
        });
      }
    },
    userPerm(path) {
      if (this.pagePermission) {
        const reFormant = path.split("-").join("_");
        const user_type = this.user.user_type;
        // const user_type = "leadership";
        if (
          this.pagePermission[reFormant] &&
          this.pagePermission[reFormant][user_type]
        ) {
          if (reFormant == "integrations" && this.companyData) {
            const perm =
              this.companyData.show_integration &&
              this.companyData.show_integration == "Y";
            return perm && this.pagePermission[reFormant][user_type];
          } else {
            return this.pagePermission[reFormant][user_type];
          }
        }
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  90% {
    transform: rotate(0);
  }
  92% {
    transform: rotate(-15deg);
  }
  95% {
    transform: rotate(25deg);
  }
  98% {
    transform: rotate(-15deg);
  }
  100% {
    transform: rotate(0);
  }
}

.animation-logo {
  animation: rotate;
  animation-iteration-count: infinite;
  animation-duration: 38s;
}

* {
  transition: 0.2s;
}
.md-app {
  min-height: calc(100vh - 32px);
}
.md-drawer {
  width: 256px;
  //  min-width: 256px;
  max-width: calc(100vw - 125px);
  background-color: #6c30cc;
}
.md-list {
  background-color: #6c30cc;
}
.md-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0px;
}
.md-button.md-theme-default,
.md-button.md-theme-default:hover {
  text-transform: capitalize !important; /*For Lower case use lowercase*/
}
.md-list.md-theme-default .md-list-item-container {
  border-radius: 23px;
}
.md-list-item:hover {
  background: #5423a2;
  .logout-text {
    color: #fff;
  }
}
.card-tutorial.members {
  top: 210px;
}
.card-tutorial.questions {
  top: 262px;
}
.card-tutorial.rewards {
  top: 312px;
}
.card-tutorial.insights {
  top: 158px;
}
.card-tutorial.settings {
  top: 526px;
}
.card-tutorial {
  position: absolute;
  left: 180px;
  width: calc(540px - 52px);
  height: calc(480px - 52px);
  background-color: #fff;
  padding: 52px;
  word-break: break-word;
  box-shadow: 0 0 44px #0000003b;
}
.title-tutorial {
  font-size: 28px;
  font-weight: 900;
}
.content-tutorial {
  font-size: 16px;
}
.skip-tutorial {
  font-size: 16px;
  color: #747474;
  font-weight: 700;
}
.next-tutorial {
  font-size: 16px;
  color: #32c2d5;
  font-weight: 700;
  margin-left: auto;
}
.arrow-tutorial {
  position: absolute;
  border: 20px solid;
  left: -92px;
  top: 60px;
  border-color: transparent #fff transparent transparent;
}
.web-page-container {
  .mock-navbar {
    width: 100vw;
    // height: 56px; // Coding
    height: 0px;
    @media only screen and (max-width: 1024px) {
      height: 56px;
    }
  }
  .navbar {
    position: fixed;
    height: 56px;
    // top: 0px; // Coding
    top: -56px;
    z-index: 99;
    transition: 0;
    @media only screen and (max-width: 1024px) {
      top: 0px;
      box-shadow: 0 0 12px #00000090;
    }
    width: 100vw;
    background-color: #5423a2;

    .hamburger-bar {
      cursor: pointer;
      padding: 6px;
      width: calc(40px - 6px);
      margin: 2px 16px 6px auto;
      .line-menu {
        width: 24px;
        height: 4px;
        border-radius: 2px;
        background-color: black;
        margin-top: 4px;
        opacity: 0.2;
      }
    }
  }
  .menu-container {
    z-index: 50;
    width: 0px;
    padding-right: 224px;
    position: relative;
    @media only screen and (max-width: 1024px) {
      padding-right: 0px;
    }
    .side-menu {
      transition: 0.2;
      width: 224px;
      position: absolute;
      right: 0;
      transition: height 0;
      background-color: #6c30cc;
      min-height: calc(100vh - 32px);
      .header-menu {
        background-color: #5423a2;
        padding: 24px 20px 22px;
        .happily-logo {
          @media only screen and (max-width: 1024px) {
            display: none;
          }
        }
        .name {
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .body-menu {
        padding: 28px 16px;
        background-color: #6c30cc;
        .router {
          transition: 0.2s;
          height: calc(48px - 8px);
          opacity: 0.72;
          width: calc(100% - 32px);
          padding: 4px 16px;
          cursor: pointer;
          border-radius: 44px;
          margin-bottom: 4px;
          &:hover {
            opacity: 1;
            background: #5423a2;
          }
          .label {
            margin-left: 32px;
            color: #fff;
            font-size: 14px;
            font-family: "Roboto";
            font-weight: 500;
          }
        }
        .router.active {
          opacity: 1;
          background: #5423a2;
        }
      }
    }
  }
  .menu-container.show-menu {
    padding-right: 0px;
    @media only screen and (min-width: 1023px) {
      padding-right: 224px;
    }
    .side-menu {
      right: -224px;
      @media only screen and (min-width: 1023px) {
        right: 0;
      }
    }
  }
  .components-container {
    width: calc(100vw - 225px);
  }
}
</style>
